module.exports = __webpack_public_path__ + "img/map_button_external.cb64c1b2.svg";